import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Header, Dimmer } from 'semantic-ui-react';
import Icon from '../../elementals/icon';
import Button from '../../elementals/button';
import Text from '../../elementals/text';
import Modal from '../../overlays/modal';
import PhotoManagement from '../photoManagement';
const PhotoManagementModal = ({ isOpen, photos, property, onConfirm, onModalClose, updatePhotos, loading, trigger, settings, maxFileSize, maxPhotosAllowed, }) => {
    return (_jsxs(Modal, { open: isOpen, size: 'large', closeIcon: false, "data-elm-id": 'photo_management_modal', trigger: trigger, children: [_jsx(Header, { children: _jsxs(Header.Content, { children: [_jsxs(Text, { weight: 'heavy', size: 'large', children: [_jsx(Icon, { name: 'image', iconStyle: 'solid' }), " Manage Photos for", ' ', _.get(property, 'summary.street_address', '')] }), _jsx(Text, { className: 'u-mt-1', size: 'tiny', children: settings.hideUnusedPhotos
                                ? 'Specify photos to show on the listing. Drag-and-drop to reorder.'
                                : 'Specify photos to show on the current listing. Drag-and-drop to reorder, and/or remove.' })] }) }), _jsx(Modal.Content, { children: _jsxs(Dimmer.Dimmable, { dimmed: true, blurring: loading, children: [_jsx(Dimmer, { inverted: true, active: loading, children: "Uploading" }), _jsx(PhotoManagement, { photos: photos, property: property, updatePhotos: updatePhotos, settings: settings, maxFileSize: maxFileSize, maxPhotosAllowed: maxPhotosAllowed })] }) }), _jsxs(Modal.Actions, { children: [_jsx(Button, { role: 'secondary', elmId: 'on_modal_close', onClick: onModalClose, children: "Cancel" }), _jsx(Button, { role: 'primary', elmId: 'on_modal_confirm', onClick: onConfirm, loading: loading, disabled: loading, children: "Save" })] })] }));
};
PhotoManagementModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onConfirm: PropTypes.func.isRequired,
    onModalClose: PropTypes.func.isRequired,
    updatePhotos: PropTypes.func.isRequired,
    property: PropTypes.object,
    photos: PropTypes.array,
    loading: PropTypes.bool,
    trigger: PropTypes.any.isRequired,
    settings: PropTypes.object,
    maxFileSize: PropTypes.number,
    maxPhotosAllowed: PropTypes.number,
};
PhotoManagementModal.defaultProps = {
    property: {},
    photos: [],
    loading: false,
    settings: {},
};
export default PhotoManagementModal;
//# sourceMappingURL=index.js.map